import { CarouselProps } from 'components/carousel/carousel.types';

export const resolveSlidesLength = (props: CarouselProps) => {
  return props.photos.length + +!!props.videoUrl;
};
